// extracted by mini-css-extract-plugin
export default {"container":"ModuleStudents_container__v-eY1","students":"ModuleStudents_students__Gkh-+","student":"ModuleStudents_student__r0NCn"};